document.addEventListener("DOMContentLoaded", function() {
  
  topBarSlider();
  
});


document.addEventListener('StartAsyncLoading',function(event){
  
  //topBarSlider();
  blogSlider();
  iconWithTextSlider();
  featuredCollection();
  relatedProduct();
  brandLogoSlider();
  checklistslider();
  testimonialSlider();
  shoppingBoxSlider();
  complementrySlider();
  // proMainGallary();
  bundle_product();
  
});


function topBarSlider() { 
  if(!document.querySelector('.top-bar-wrapper .topBarSlider')) return;
  
  var swiper = new Swiper(".topBarSlider", {    
      slidesPerView: 'auto',
      spaceBetween: 20,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 80,
        },
      },
  });    
} 

function blogSlider() { 
  if(!document.querySelector('.section-featured-blog-wrapper .blogSlider')) return;
  
  var swiper = new Swiper(".blogSlider", {    
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".blogslide-next",
        prevEl: ".blogslide-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 4.2,
          spaceBetween: 20,
        },
      },
  });    
}

function iconWithTextSlider() { 
  if(!document.querySelector('.icon-with-text-wrapper .iconWithTextSlider')) return;
  
  var swiper = new Swiper(".iconWithTextSlider", {    
      slidesPerView: 4,
      spaceBetween: 0,      
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".icon-next",
        prevEl: ".icon-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 0,   
          centeredSlides: true,   
          loop: true,
        },        
        750: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
  });    
}

function featuredCollection() {
  if(!document.querySelector('.featured-collection-wrapper .featuredCollection')) return;

  let desktopSliderPerView = Number(document.querySelector('.featuredCollection').dataset.sliderPerShow || 4);
  var swiper = new Swiper(".featuredCollection", {  
    navigation: {
      nextEl: ".featuredButtion-next",
      prevEl: ".featuredButtion-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    spaceBetween: 6,
      breakpoints: {
        10: {
          slidesPerView: 'auto',
          spaceBetween: 10,           
        },
        450: {
          slidesPerView: 'auto',
          spaceBetween: 10,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 6,
        },
        1199: {
          slidesPerView: desktopSliderPerView,
          spaceBetween: 6,
        },
      },
  });    
}

function relatedProduct() { 
  if(!document.querySelector('.related-products-wrapper .relatedProduct')) return;

  let desktopSliderPerView = Number(document.querySelector('.relatedProduct').dataset.sliderPerShow || 4);
  var swiper = new Swiper(".relatedProduct", {  
    navigation: {
      nextEl: ".relatedButtion-next",
      prevEl: ".relatedButtion-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    spaceBetween: 6,
      breakpoints: {
        10: {
          slidesPerView: 2,
          spaceBetween: 6,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 6,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 6,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 6,
        },
        1199: {
          slidesPerView: desktopSliderPerView,
          spaceBetween: 6,
        },
      },
  });    
}

function checklistslider() { 
  if(!document.querySelector('.check-list-wrapper .checklistslider')) return;
  
  var swiper = new Swiper(".checklistslider", {    
    slidesPerView: 'auto',
    spaceBetween: 60,     
    // navigation: {
    //   nextEl: ".footButton-next",
    //   prevEl: ".footButton-prev",
    // },
    breakpoints: {  
        10: {
          slidesPerView: 2,
          spaceBetween: 0,                   
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 0,          
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,          
        },
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 60,          
        }
      },
  });    
}

function brandLogoSlider() { 
  if(!document.querySelector('.brand-logos-wrapper .brandLogoSlider')) return;  
  var swiper = new Swiper(".brandLogoSlider", {          
      spaceBetween: 40,
      centeredSlides: true,
      speed: 6000,
      autoplay: {
        delay: 1,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: true,
      slidesPerView:'auto',
      allowTouchMove: false,
      disableOnInteraction: true,
      breakpoints: {
        10: {
          spaceBetween: 15,
        },       
        750: {
          spaceBetween: 40,
        },
        991: {
          spaceBetween: 40,
        },       
      },
  });    
}

function testimonialSlider() { 
  if(!document.querySelector('.testimonials-box-wrapper .testimonialSlider')) return;  
  var swiper = new Swiper(".testimonialSlider", {    
      slidesPerView: 'auto',
      spaceBetween: 10,     
      centeredSlides: true,
      initialSlide: 1,
      navigation: {
        nextEl: ".testi-next",
        prevEl: ".testi-prev",
      },      
      breakpoints: {  
        10: {
          slidesPerView: 'auto',
          spaceBetween: 20,        
        },
        450: {
          slidesPerView: 'auto',
          spaceBetween: 20,          
        },        
        1199: {
          slidesPerView: 'auto',
          spaceBetween: 10,
        },
      },
  });    
}

function bundle_product() {  
   if(!document.querySelector('.main-product-wrapper .cstm_product_swiper')) return;
   var parentSwiper = new Swiper('.cstm_product_swiper', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 5,
      loop: false,
      autoHeight: true,
      pagination:{
         el: '.swiper-pagination',
         clickable:true
       },
     navigation: {
        nextEl: ".bundle_product-next",
        prevEl: ".bundle_product-prev",
      }, 
      // breakpoints:{
      //   0: {
      //     navigation: false,
      //     slidesPerView:1.3
      //   },
      //   375: {
      //     navigation: false,
      //     slidesPerView:2.3
      //   },
      //   750: {
      //     navigation: false,
      //     slidesPerView:1.7
      //     // pagination: true
      //    },
      //   1199: {
      //     navigation: false,
      //     slidesPerView:2.7
      //     // pagination: true
      //    }
      //  }
    });
}
function shoppingBoxSlider() { 
  if(!document.querySelector('.shopping-box-slider-wrapper .shoppingBoxSlider')) return;  
  var swiper = new Swiper(".shoppingBoxSlider", {          
      spaceBetween: 0,
      slidesPerView:1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },  
      navigation: {
        nextEl: ".shop-next",
        prevEl: ".shop-prev",
      },
  });    
}

function complementrySlider() { 
  if(!document.querySelector('.main-product-wrapper .complementrySlider')) return;  
  var swiper = new Swiper(".complementrySlider", {          
      spaceBetween: 0,
      slidesPerView:1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },  
      navigation: {
        nextEl: ".complementrySlider-next",
        prevEl: ".complementrySlider-prev",
      },
  });    
}



function proMainGallary() {  

    // Initialize the thumbnail slider first
    var proMainSliderThumb = new Swiper(".proMainSliderThumb", {
      direction: "vertical",
      loop: true,
      slidesPerView: 5,
      slideToClickedSlide: true,
      spaceBetween: 6,          
    });

    // Initialize the main product slider with the thumbnails linked
    var proMainSlider = new Swiper(".proMainSlider", {
      slidesPerView: 1,    
      spaceBetween: 6,
      pagination: {
        el: ".pro-swiper-pagination",
        clickable: true,
      },  
      navigation: {
        nextEl: ".main-pro-next",
        prevEl: ".main-pro-prev",
      },
      thumbs: {
        swiper: proMainSliderThumb, 
      },
    });  
   
}






if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
        const topBarSliderSection = event.target.closest('.top-bar-wrapper') || null;
        if(topBarSliderSection){
          topBarSlider();
        } 
 
        const blogSliderSection = event.target.closest('.section-featured-blog-wrapper') || null;
        if(blogSliderSection){
          blogSlider();
        }

        const iconWithTextSliderSection = event.target.closest('.icon-with-text-wrapper') || null;
        if(iconWithTextSliderSection){
          iconWithTextSlider();
        }

        const featuredCollectionWrapper = event.target.closest('.featured-collection-wrapper') || null;
        if(featuredCollectionWrapper){
          featuredCollection();
        }
      
        const relatedProductWrapper = event.target.closest('.related-products-wrapper') || null;
        if(relatedProductWrapper){
          relatedProduct();
        }

        const brandLogoSliderWrapper = event.target.closest('.logo-list-wrapper') || null;
        if(brandLogoSliderWrapper){
          brandLogoSlider();
        }

        const checklistsliderWrapper = event.target.closest('.check-list-wrapper') || null;
        if(checklistsliderWrapper){
          checklistslider();
        }

       const testimonialSliderSection = event.target.closest('.testimonials-box-wrapper') || null;
          if(testimonialSliderSection){
            testimonialSlider();
        }

      const shoppingBoxSliderSection = event.target.closest('.shopping-box-slider-wrapper') || null;
          if(shoppingBoxSliderSection){
            shoppingBoxSlider();
        }
      
      const complementrySliderSection = event.target.closest('.main-product-wrapper') || null;
          if(complementrySliderSection){
            complementrySlider();
        }


     const proMainGallarySection = event.target.closest('.main-product-wrapper') || null;
        if(proMainGallarySection){
          // proMainGallary();
      }


     
         
        
    });
  });
}

// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();                  
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  } 

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

 
document.addEventListener("DOMContentLoaded", function () {
  const headerMenuItems = document.querySelectorAll('li > header-menu');


  headerMenuItems.forEach(function(menuItem) {
    const details = menuItem.querySelector('details');
    

    if (details) {
      menuItem.addEventListener('mouseenter', function() {
        details.setAttribute('open', '');  
      });

      menuItem.addEventListener('mouseleave', function() {
        details.removeAttribute('open'); 
      });
    }
  });
});


//  For Footer part
 $(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.js-acc-single-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
   
  if ($(window).width() < 750){  
    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
        $this = $(this),
        $next = $this.next();
  
      $next.slideToggle();
      $this.parent().toggleClass('open');
  
      if (!e.data.multiple) {
        $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
      };
    } 
  }
  var accordion = new Accordion($('.my-accordion'), false);
});


// bundle pdp
function custom_addtocart_fun(product,open_drawer){
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {              
          // console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
            this_cartDrawer.refresh(true);
          }
        });
}


$(document).ready(function() {

	$('.image-popup-no-margins').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		fixedContentPos: true,
		mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
		image: {
			verticalFit: true
		},
		zoom: {
			enabled: true,
			duration: 300 // don't foget to change the duration also in CSS
		}
	});

});
 

$(document).ready(function() {
  
  // Initialize Magnific Popup once for the image links
  $('.image-popup-fit-width').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    image: {
      verticalFit: false
    }
  });

  // Add hover event to open Magnific Popup on hover for each individual image
  $('.image-popup-fit-width').on('mouseenter', function() {
    // Open the popup for the hovered image only
    $(this).magnificPopup('open');
  });
});


const appHeight = () => {
 const doc = document.documentElement
 doc.style.setProperty("--vh", `${window.innerHeight}px`)
}
window.addEventListener("resize", appHeight)
appHeight()

const dbutton = document.getElementById("sub-drawer-close");
if(dbutton){
   dbutton.addEventListener("click", function(event) {
    console.log("click");
        // event.preventDefault(); 
        document.querySelectorAll(".submenu-drawer-button").forEach(button => {
            button.click(); // Trigger click event on all buttons
        });        
    });
}
 
const review_click = document.querySelector(".jdgm-prev-badge");
if(review_click)
{
  review_click.addEventListener("click",function(e) {
    const review = document.querySelector(".heading_review");
    if(review){
      review.click();      
    }
  });
}